var _defs, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.751,
    height: 12.751,
    "data-name": "Icons / Arrows / arrow-right",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h12.751v12.751H0z",
    "data-name": "Icons / Arrows / arrow-right (Background/Mask)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h12.751v12.751H0z",
    "data-name": "Icons / Arrows / arrow-right (Background/Mask)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    "data-name": "Icons / Arrows / arrow-right"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fff",
    strokeDasharray: "0 0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.594 6.376h9.563",
    "data-name": "Vector 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.969 9.564 3.188-3.188-3.188-3.188",
    "data-name": "Polygon 1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.ca9aa705c9dec722abe9690a3e43c32f.svg";
export { ForwardRef as ReactComponent };